import * as React from "react";

function SvgImageNow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.933 0h10.134c.738 0 1.333.58 1.333 1.3v2.23h7.457C32.598 3.53 34 4.897 34 6.594v17.261l-.001.082.001.147C34 29.56 29.56 34 24.083 34c-4.492 0-8.287-2.987-9.506-7.083H3.143C1.402 26.917 0 25.55 0 23.854V6.593C0 4.896 1.402 3.53 3.143 3.53H10.6V1.299C10.6.58 11.195 0 11.933 0zm3.65 24.083v-.002a8.503 8.503 0 0110.595-8.238 8.503 8.503 0 016.018 10.785 8.504 8.504 0 01-16.129.289 8.487 8.487 0 01-.484-2.834zm10.577-9.699a8.87 8.87 0 00-2.655-5.5A9.324 9.324 0 0017 6.26c-2.44 0-4.78.945-6.505 2.626A8.85 8.85 0 007.8 15.224a8.85 8.85 0 002.695 6.339 9.244 9.244 0 003.677 2.191 9.923 9.923 0 01.264-1.975 7.22 7.22 0 01-2.527-1.595 6.926 6.926 0 01-2.109-4.96c0-1.861.759-3.646 2.109-4.961A7.297 7.297 0 0117 8.208c1.91 0 3.74.739 5.091 2.055a6.952 6.952 0 012.027 3.904 9.95 9.95 0 012.042.217z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.988 29.042a8.462 8.462 0 001.595-4.959c0-1.548-.414-3-1.137-4.25h-9.488l-2.125 2.125v9.488a8.461 8.461 0 004.25 1.137c1.85 0 3.563-.591 4.959-1.595v-1.946h1.946zm-6.905-7.084h-2.125v2.125h2.125v-2.125zm3.542 0H25.5v2.125h2.125v-2.125zm1.417 0h2.125v2.125h-2.125v-2.125zM24.083 25.5h-2.125v2.125h2.125V25.5zm3.542 0H25.5v2.125h2.125V25.5zm1.417 0h2.125v2.125h-2.125V25.5zm-7.084 3.542h2.125v2.125h-2.125v-2.125zm3.542 0h2.125v2.125H25.5v-2.125z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgImageNow;
